/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function ImportCellInfoFromJSON(json) {
    return ImportCellInfoFromJSONTyped(json, false);
}
export function ImportCellInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        accountTagId: json['accountTagId'],
        count: json['count'],
    };
}
export function ImportCellInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        accountTagId: value.accountTagId,
        count: value.count,
    };
}
